var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 94,
    viewBox: "0 0 66 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 46.9998C33 43.1984 34.5101 39.5527 37.1981 36.8646C39.8862 34.1766 43.5319 32.6665 47.3333 32.6665C51.1348 32.6665 54.7805 34.1766 57.4685 36.8646C60.1566 39.5527 61.6667 43.1984 61.6667 46.9998C61.6667 50.8013 60.1566 54.447 57.4685 57.135C54.7805 59.8231 51.1348 61.3332 47.3333 61.3332C43.5319 61.3332 39.8862 59.8231 37.1981 57.135C34.5101 54.447 33 50.8013 33 46.9998Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 75.6668C4.33398 71.8654 5.8441 68.2197 8.53212 65.5316C11.2201 62.8436 14.8659 61.3335 18.6673 61.3335H33.0007V75.6668C33.0007 79.4683 31.4905 83.114 28.8025 85.802C26.1145 88.49 22.4688 90.0002 18.6673 90.0002C14.8659 90.0002 11.2201 88.49 8.53212 85.802C5.8441 83.114 4.33398 79.4683 4.33398 75.6668Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bii_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 4V32.6667H47.3333C51.1348 32.6667 54.7805 31.1566 57.4685 28.4685C60.1566 25.7805 61.6667 22.1348 61.6667 18.3333C61.6667 14.5319 60.1566 10.8862 57.4685 8.19814C54.7805 5.51011 51.1348 4 47.3333 4L33 4Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bii_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 18.3333C4.33398 22.1348 5.8441 25.7805 8.53212 28.4685C11.2201 31.1566 14.8659 32.6667 18.6673 32.6667H33.0007V4H18.6673C14.8659 4 11.2201 5.51011 8.53212 8.19814C5.8441 10.8862 4.33398 14.5319 4.33398 18.3333Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bii_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 46.9998C4.33398 50.8013 5.8441 54.447 8.53212 57.135C11.2201 59.8231 14.8659 61.3332 18.6673 61.3332H33.0007V32.6665H18.6673C14.8659 32.6665 11.2201 34.1766 8.53212 36.8646C5.8441 39.5527 4.33398 43.1984 4.33398 46.9998Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_231_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 46.9998C33 43.1984 34.5101 39.5527 37.1981 36.8646C39.8862 34.1766 43.5319 32.6665 47.3333 32.6665C51.1348 32.6665 54.7805 34.1766 57.4685 36.8646C60.1566 39.5527 61.6667 43.1984 61.6667 46.9998C61.6667 50.8013 60.1566 54.447 57.4685 57.135C54.7805 59.8231 51.1348 61.3332 47.3333 61.3332C43.5319 61.3332 39.8862 59.8231 37.1981 57.135C34.5101 54.447 33 50.8013 33 46.9998V46.9998Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 75.6668C4.33398 71.8654 5.8441 68.2197 8.53212 65.5316C11.2201 62.8436 14.8659 61.3335 18.6673 61.3335H33.0007V75.6668C33.0007 79.4683 31.4905 83.114 28.8025 85.802C26.1145 88.49 22.4688 90.0002 18.6673 90.0002C14.8659 90.0002 11.2201 88.49 8.53212 85.802C5.8441 83.114 4.33398 79.4683 4.33398 75.6668Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 46.9998C4.33398 50.8013 5.8441 54.447 8.53212 57.135C11.2201 59.8231 14.8659 61.3332 18.6673 61.3332H33.0007V32.6665H18.6673C14.8659 32.6665 11.2201 34.1766 8.53212 36.8646C5.8441 39.5527 4.33398 43.1984 4.33398 46.9998Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 18.3333C4.33398 22.1348 5.8441 25.7805 8.53212 28.4685C11.2201 31.1566 14.8659 32.6667 18.6673 32.6667H33.0007V4H18.6673C14.8659 4 11.2201 5.51011 8.53212 8.19814C5.8441 10.8862 4.33398 14.5319 4.33398 18.3333Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4V32.6667H47.3333C51.1348 32.6667 54.7805 31.1566 57.4685 28.4685C60.1566 25.7805 61.6667 22.1348 61.6667 18.3333C61.6667 14.5319 60.1566 10.8862 57.4685 8.19814C54.7805 5.51011 51.1348 4 47.3333 4L33 4Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 46.9998C33 43.1984 34.5101 39.5527 37.1981 36.8646C39.8862 34.1766 43.5319 32.6665 47.3333 32.6665C51.1348 32.6665 54.7805 34.1766 57.4685 36.8646C60.1566 39.5527 61.6667 43.1984 61.6667 46.9998C61.6667 50.8013 60.1566 54.447 57.4685 57.135C54.7805 59.8231 51.1348 61.3332 47.3333 61.3332C43.5319 61.3332 39.8862 59.8231 37.1981 57.135C34.5101 54.447 33 50.8013 33 46.9998V46.9998Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 75.6668C4.33398 71.8654 5.8441 68.2197 8.53212 65.5316C11.2201 62.8436 14.8659 61.3335 18.6673 61.3335H33.0007V75.6668C33.0007 79.4683 31.4905 83.114 28.8025 85.802C26.1145 88.49 22.4688 90.0002 18.6673 90.0002C14.8659 90.0002 11.2201 88.49 8.53212 85.802C5.8441 83.114 4.33398 79.4683 4.33398 75.6668Z",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 46.9998C4.33398 50.8013 5.8441 54.447 8.53212 57.135C11.2201 59.8231 14.8659 61.3332 18.6673 61.3332H33.0007V32.6665H18.6673C14.8659 32.6665 11.2201 34.1766 8.53212 36.8646C5.8441 39.5527 4.33398 43.1984 4.33398 46.9998Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 18.3333C4.33398 22.1348 5.8441 25.7805 8.53212 28.4685C11.2201 31.1566 14.8659 32.6667 18.6673 32.6667H33.0007V4H18.6673C14.8659 4 11.2201 5.51011 8.53212 8.19814C5.8441 10.8862 4.33398 14.5319 4.33398 18.3333Z",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4V32.6667H47.3333C51.1348 32.6667 54.7805 31.1566 57.4685 28.4685C60.1566 25.7805 61.6667 22.1348 61.6667 18.3333C61.6667 14.5319 60.1566 10.8862 57.4685 8.19814C54.7805 5.51011 51.1348 4 47.3333 4L33 4Z",
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_231_194",
    x: 29,
    y: 28.6665,
    width: 36.666,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_194",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_194"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_194",
    result: "effect3_innerShadow_231_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_231_194",
    x: 0.333984,
    y: 57.3335,
    width: 36.666,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_194",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_194"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_194",
    result: "effect3_innerShadow_231_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bii_231_194",
    x: 29,
    y: 0,
    width: 36.666,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_194",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_194"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_194",
    result: "effect3_innerShadow_231_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bii_231_194",
    x: 0.333984,
    y: 0,
    width: 36.666,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_194",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_194"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_194",
    result: "effect3_innerShadow_231_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bii_231_194",
    x: 0.333984,
    y: 28.6665,
    width: 36.666,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_194",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_194"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_194",
    result: "effect3_innerShadow_231_194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_231_194",
    x: 0.333984,
    y: 0,
    width: 65.332,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_231_194"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.f18dae56cd6cf730228c9cdc4c4081da.svg";
export { ForwardRef as ReactComponent };